import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AppConstants } from 'appshared/app-constants';
// import * as Models from 'appshared/models/shared';
import { RoleGuard } from 'client/app/guards/role.guard';
import { PlatformComponent } from './platform/platform.component';
import { PlatformListComponent } from './platform-list/platform-list.component';
import { PlatformFormComponent } from './platform-form/platform-form.component';
import { PlatformsResolverService } from './platforms-resolver.service';
import { ProductsResolverService } from '../products/products-resolver.service';

const routes: Routes = [
	{
		path: '',
		component: PlatformListComponent,
		canActivate: [RoleGuard],
		data: { role: AppConstants.staffUserRole },
		resolve: [PlatformsResolverService]
	}, {
		path: 'new',
		component: PlatformFormComponent,
		canActivate: [RoleGuard],
		data: { role: AppConstants.staffUserRole }
	}, {
		path: ':id',
		component: PlatformComponent,
		canActivate: [RoleGuard],
		data: { role: AppConstants.staffUserRole },
		resolve: [PlatformsResolverService, ProductsResolverService]
	}, {
		path: ':id/edit',
		component: PlatformFormComponent,
		canActivate: [RoleGuard],
		data: { role: AppConstants.staffUserRole },
		resolve: [PlatformsResolverService]
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class PlatformsRoutingModule { }
